<template>
  <div>
    <el-group-title
      title="合同附件"
      class="ccui-group-wrapper d_jump"
      index="contract"
    >
      <template slot="groupTitle">
        <el-form
          :model="form"
          :rules="rules"
          ref="form2"
          label-width="160px"
          class="ccui-form"
          style="overflow:visible;"
        >
          <el-table
            :data="tableData"
            style="margin-bottom:20px;width:100%;"
            border
            max-height="99999"
          >
            <el-table-column
              :show-overflow-tooltip="true"
              label="序号"
              type="index"
              min-width="20%"
              height="36px"
            />
            <el-table-column
              :show-overflow-tooltip="true"
              prop="textName"
              label="文件名称"
              min-width="140%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="txtlarge"
              label="文件大小"
              min-width="70%"
            >
            </el-table-column>
            <el-table-column
              :show-overflow-tooltip="true"
              prop="scaleNum"
              label="操作"
              min-width="70%"
              align="center"
              header-align="center"
            >
              <template>
                <span style="color:#0089EF;cursor:pointer">下载</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </template>
    </el-group-title>
  </div>
</template>

<script>
export default {
  name: "attachment",
  props: {
    attachment: {
      type: Array,
      default() {
        return [];
      }
    },
    financeInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      form: {
        priceRegion: "北京",
        taxMethod: "增值税",
        taxType: "一般税",
        placeSign: "北京",
        numberCopies: "2",
        phonePerson: "小名",
        taxpayer: "自然纳税人",
        materialSources: "北京",
        paymentCoefficient: "1",
        advanceCharge: "100000",
        titleAccount: "北京银行",
        accountNumber: "10000",
        accountName: "6213"
      },
      rules: {},
      tableData: [
        {
          id: "1",
          textName: "采购清单.xlsx",
          txtlarge: "12Kb"
        }
      ]
    };
  },
  watch: {
    financeInfo() {
      this.form = this.financeInfo;
    },
    attachment() {
      this.tableData = this.attachment;
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-table {
  /deep/th {
    padding: 0;
    heigth: 36px;
    line-height: 36px;
  }
  .el-table__body {
    .cell {
      height: 36px;
      line-height: 36px;
    }
  }
}
</style>
